export default __webpack_public_path__ + "static/OurTeam-7b8d343c51a28244b1e15f4903c5b154.webp";